import { forwardRef } from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import type {
  TDropdownMenuTriggerElement,
  TDropdownMenuTriggerProps,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenu.config";

export const DropdownMenuTrigger = forwardRef<TDropdownMenuTriggerElement, TDropdownMenuTriggerProps>(
  (props, ref) => (
    <DropdownMenuPrimitive.Trigger
      data-component="DropdownMenuTrigger"
      ref={ref}
      {...props}
    />
  ),
);

DropdownMenuTrigger.displayName = DropdownMenuPrimitive.Trigger.displayName;
